import { useState, useEffect } from "react";

export const useVersionCheck = (checkIntervalMs: number = 300000) => {
  const [newVersionAvailable, setNewVersionAvailable] = useState(false);
  const [currentVersion, setCurrentVersion] = useState<string | null>(null);

  useEffect(() => {
    const checkVersion = async () => {
      try {
        const response = await fetch("/index.html", {
          cache: "no-cache",
          headers: { "Cache-Control": "no-cache" },
        });
        const html = await response.text();
        const match = html.match(/<meta name="app-version" content="([^"]+)"/);
        const serverVersion = match?.[1];

        if (!currentVersion) {
          setCurrentVersion(serverVersion || null);
        } else if (serverVersion && serverVersion !== currentVersion) {
          setNewVersionAvailable(true);
        }
      } catch (error) {
        console.error("Version check failed:", error);
      }
    };

    checkVersion();
    const interval = setInterval(checkVersion, checkIntervalMs);

    // Development testing: expose function to force new version banner
    if (process.env.NODE_ENV === "development") {
      (window as any).forceNewVersion = () => {
        console.log("Forcing new version banner for testing");
        setNewVersionAvailable(true);
      };
    }

    return () => clearInterval(interval);
  }, [currentVersion, checkIntervalMs]);

  const handleUpdate = () => {
    window.location.reload();
  };

  return { newVersionAvailable, handleUpdate };
};
